import {Component, ElementRef, Injector, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {LayoutService} from './service/app.layout.service';
import {SessionStorageService} from '../services/session-storage.service';
import {Router, RouterLink} from '@angular/router';
import {RoutingConstants} from '../models/routing/routing-constants';
import {User} from '../models/user';
import {DialogService} from 'primeng/dynamicdialog';
import {Translations} from '../services/translations.service';
import {AclPermission} from '../models/acl/acl-group';
import {ProfileButtonComponent} from '../components/profile-button/profile-button.component';

@Component({
  standalone: true,
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  imports: [
    RouterLink
  ],
  styleUrls: ['./app.topbar.component.scss']
})
export class AppTopBarComponent {
  user: User = new User();

  menu: MenuItem[] = [];

  @ViewChild('searchinput') searchInput!: ElementRef;

  @ViewChild('menubutton') menuButton!: ElementRef;

  searchActive = false;

  AclPermission = AclPermission;
  protected readonly RoutingConstants = RoutingConstants;


  constructor(public layoutService: LayoutService,
              private router: Router,
              private dialogService: DialogService,
              public translations: Translations,
              private sessionService: SessionStorageService,
              private injector: Injector) {
    this.user = sessionService.userData;
  }

  removeTab(event: MouseEvent, item: MenuItem, index: number) {
    this.layoutService.onTabClose(item, index);
    event.preventDefault();
  }
  get colorScheme(): string {
    return this.layoutService.config.colorScheme;
  }

  get tabs(): MenuItem[] {
    return this.layoutService.tabs;
  }

  onMenuToggle() {
    this.layoutService.onMenuToggle();
  }

}
